const RandomNumber = (min, max) => Math.floor(Math.random() * (max - min) + min);

export default RandomNumber;
